<template>
  <div class="app-detection-detail-view"
       v-loading="loading">
    <router-link class="back-link"
                 :to="{name: 'appDetection'}">
      <i class="gt-icon-arrow-left"></i>
      <span>返回</span>
    </router-link>
    <div class="view-title">
      <h2>APP信息</h2>
    </div>
    <div class="detail-content">
      <div class="list-wrap">
        <ul class="list">
          <li class="list-item">
            <label>App名称</label>
            <span>{{record.appName}}</span>
          </li>
          <li class="list-item">
            <label>App版本号</label>
            <span>{{record.version}}</span>
          </li>
          <li class="list-item">
            <label>运行平台系统</label>
            <span>{{record.platform === 0 ? 'android' : 'IOS'}}</span>
          </li>
          <li class="list-item">
            <label>MD5</label>
            <span>{{record.md5}}</span>
          </li>
          <li class="list-item">
            <label>提交时间</label>
            <span>{{$moment(record.submitTime).format("YYYY-MM-DD HH:mm")}}</span>
          </li>
        </ul>
      </div>
      <div class="list-wrap">
        <!--
            状态为失效，点击查看详情，展示：当前状态，补正信息，补正有效期；
            状态为已提交0、受理1、检测中2、检测通过5。检测状态中，只需要展示检测进度。（检测下方的，原因和时间都不需要展示）；
            状态为补正，展示信息是检测进度、补正信息、补正有效期。（和目前一致）  底部操作按钮：重新提交材料
            状态为不通过，展示信息是检测进度、不通过原因。底部操作按钮：重新提交材料 -->
        <ul class="list">
          <li class="list-item">
            <label>检测进度</label>
            <span>{{getStatus(record.status)}}</span>
          </li>
          <li class="list-item"
              v-if="![0,1,2,5].includes(record.status)">
            <label>{{(record.status === 3 || record.status === 6) ? '补正信息' : '不通过原因'}}</label>
            <ul class="sub-list">
              <li v-for="(vm, $index) in record.comment"
                  :key="$index">
                <span>{{vm}}</span>
              </li>
            </ul>
          </li>
          <li class="list-item"
              v-if="![0,1,2,4,5].includes(record.status)">
            <label>{{(record.status === 3 || record.status === 6) ? '补正有效期' : '重新提交有效期'}}</label>
            <span>{{record.verifyExpire}}</span>
          </li>
        </ul>
      </div>
    </div>
    <div class="detail-footer">
      <!-- 后端说只有补正才能重新提交 -->
      <router-link v-if="record.status === 3 || record.status === 4"
                   class="theme-btn"
                   :to="{name: 'appSafeDetection', query: {type: 'update',appId: $route.params.appId, status: record.status}}">重新提交检测</router-link>
    </div>
  </div>
</template>

<script>
import { getDetail } from '@/api/personal/app_detection'
export default {
  name: 'AppDetail',
  data () {
    return {
      loading: true,
      record: {
        cause: '',
        serviceTrades: []
      },
      statusList: [{
        label: '全部',
        value: ''
      }, {
        label: '已提交',
        value: 0
      }, {
        label: '受理',
        value: 1
      }, {
        label: '检测中',
        value: 2
      }, {
        label: '补正',
        value: 3
      }, {
        label: '检测不通过',
        value: 4
      }, {
        label: '检测通过',
        value: 5
      }, {
        label: '失效',
        value: 6
      }]
    }
  },
  methods: {
    getStatus (status) {
      let result = this.statusList.filter(el => {
        return el.value === status
      })
      if (result.length) return result[0].label
    }
  },
  async created () {
    try {
      const data = await getDetail({ appId: Number(this.$route.params.appId) })
      let record = data.data.data
      this.loading = false
      this.record = record
    } catch (error) {
      this.loading = false
    }
  }
}
</script>

<style lang='less' scoped>
.app-detection-detail-view {
  padding-bottom: 20px;
  .back-link {
    display: block;
    margin-top: 30px;
    color: #333;
    &:hover {
      text-decoration: underline;
    }
  }
  .view-title {
    margin: 25px 0 20px 0;
    font-size: 16px;
    color: #333333;
  }
  .detail-content {
    min-height: 300px;
    padding: 20px;
    border: 1px solid #dddddd;
    .list-wrap {
      margin-bottom: 14px;
      border-bottom: 1px solid #e7e7e7;
      &:last-child {
        margin-bottom: 0;
        border-bottom: none;
      }
      .list {
        .list-item {
          margin-bottom: 10px;
          label {
            width: 104px;
            margin-right: 10px;
            display: inline-block;
            font-size: 14px;
            color: #666666;
          }
          span {
            font-size: 14px;
            color: #333333;
          }
          .sub-list {
            display: inline-block;
            vertical-align: text-top;
          }
        }
      }
    }
  }
  .detail-footer {
    margin-top: 50px;
    text-align: center;
    font-size: 14px;
    // .theme-btn {
    //   line-height: 20px;
    // }
  }
}
</style>
